module.exports = __webpack_public_path__ + "static/media/btn-fileSearch.a53eb799.svg";